import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './style.css';
import { isWebglSupported } from '../../containers/AeroPhotoTourEntry/helpers';

interface IGenplanControlsProps {
  isFloorPlanAvailable: boolean;
  isAeroPhotoTourAvailable: boolean;
  onFloorPlanClick(): void;
  onAeroPhotoClick(): void;
}

export const GenplanControls = ({
  isFloorPlanAvailable,
  isAeroPhotoTourAvailable,
  onFloorPlanClick,
  onAeroPhotoClick,
}: IGenplanControlsProps) => {
  const [isAeroPhotoTourSupported, setIsAeroPhotoTourSupported] = React.useState(false);

  React.useEffect(() => {
    setIsAeroPhotoTourSupported(isWebglSupported() && isAeroPhotoTourAvailable);
  }, []);

  return (
    <div className={styles['controls']}>
      {isFloorPlanAvailable && (
        <Button theme="fill_white_primary" onClick={onFloorPlanClick}>
          Квартиры на этажах
        </Button>
      )}
      {isAeroPhotoTourSupported && (
        <Button theme="fill_white_primary" onClick={onAeroPhotoClick}>
          Панорамный вид
        </Button>
      )}
    </div>
  );
};
